import { Star } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { useScrollAnimation } from '@/hooks/use-scroll-animation'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import testimonialAlexandre from '@/assets/testimonial-alexandre.jpg'
import testimonialMari from '@/assets/testimonial-mari.jpg'
import testimonialFernando from '@/assets/testimonial-fernando.jpg'
import testimonialBianca from '@/assets/testimonial-bianca.jpg'
import testimonialDavi from '@/assets/testimonial-davi.jpg'

const testimonials = [
  {
    id: 1,
    name: 'Alexandre Pompermayer',
    event: 'Formatura',
    rating: 5,
    text: 'Sem palavras, nunca imaginei que iria gostar tanto de um livro como esse, marcou nossas vidas, fico emocionado a cada vez que eu abro esse livro e vejo a minha caçula nele.',
    image: testimonialAlexandre,
    imagePosition: 'object-top',
  },
  {
    id: 2,
    name: 'Mari Bolzano',
    event: 'Formatura',
    rating: 5,
    text: 'Foi uma alegria imensa ter o álbum de formatura da Giulia nas minhas mãos. Depois de 9 anos de formada revivemos tantas emoções, os desafios e conquistas dos anos de faculdade. Fotos digitais são lindas mas não substituem o álbum de papel, que é uma lembrança ao alcance da mão. Ao nos reunirmos em torno do álbum criamos mais momentos especiais em família e com amigos.',
    image: testimonialMari,
  },
  {
    id: 3,
    name: 'Fernando Saldanha',
    event: 'Maratona de Veneza',
    rating: 5,
    text: 'Separar, organizar as fotos dos meus longos das provas que fiz dentro da planilha da viagem foi muito prazeroso, mas não imaginava que vendo o layout pronto ficaria tão emocionado. O álbum ficou lindo, fantástico.',
    image: testimonialFernando,
  },
  {
    id: 4,
    name: 'Bianca de Stefano',
    event: 'Viagem - Munique',
    rating: 5,
    text: 'Meu álbum de viagem ficou simplesmente maravilhoso! Cada página me faz reviver momentos únicos, que estou sempre revivendo, pois ao invés de fotos perdidas na nuvem do celular, ainda mais por deixar na mesinha de centro da sala. A qualidade das fotos está ótima, com cores vivas e acabamento impecável. Um álbum desses é construir memórias e eternizar momentos. Estou muito feliz com o resultado e já penso em fazer outros!',
    image: testimonialBianca,
    imagePosition: 'object-top',
  },
  {
    id: 5,
    name: 'Davi Xavier',
    event: 'Insane Runners Experience: Lençóis Maranhenses',
    rating: 5,
    text: 'Quando o pessoal da FotoLivro me perguntou qual edição da Insane Runners Experience eu faria, tinha que ser os Lençóis Maranhenses. Eu lembro de lá como se fosse ontem... nem eu acredito que eu estava lá! No celular, essas imagens não valorizam como deveriam. Essas fotos iriam se perder. Talvez daqui a 10 anos eu pegaria a nuvem do meu celular, deixaria as fotos mais impactantes e descartaria outras. Muito massa! Isso aqui tem valor demais!',
    image: testimonialDavi,
    imagePosition: 'object-[50%_15%]',
  },
]

const TestimonialsSection = () => {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <section className="py-24 bg-gradient-to-b from-muted/10 via-background to-muted/10">
      <div
        ref={ref}
        className={`container mx-auto px-4 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-12">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-3">
            A emoção de quem <span className="italic text-gold">recebe</span>
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Histórias reais, contadas por quem confiou suas memórias a nós.
          </p>
        </div>

        <div className="max-w-6xl mx-auto px-12">
          <Carousel
            opts={{
              align: 'start',
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {testimonials.map(testimonial => (
                <CarouselItem
                  key={testimonial.id}
                  className="md:basis-1/2 lg:basis-1/3"
                >
                  <Card className="hover:shadow-lg transition-shadow h-full">
                    <CardContent className="pt-8 pb-8 px-8">
                      <div className="flex items-center gap-4 mb-4">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className={`w-20 h-20 rounded-full object-cover ${testimonial.imagePosition || 'object-center'}`}
                          loading="lazy"
                        />
                        <div>
                          <p className="font-semibold">{testimonial.name}</p>
                          <p className="text-sm text-muted-foreground">
                            {testimonial.event}
                          </p>
                        </div>
                      </div>

                      <div className="flex mb-3">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star
                            key={i}
                            className="w-5 h-5 fill-yellow-400 text-yellow-400"
                          />
                        ))}
                      </div>

                      <p className="text-muted-foreground leading-relaxed mb-6">
                        "{testimonial.text}"
                      </p>
                    </CardContent>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="left-0" />
            <CarouselNext className="right-0" />
          </Carousel>
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection
